import { CircleQuestionRegular } from '@allocab/allocab-icons';

import { useAuth } from '../../../hooks/useAuth';
import { t } from '../../../services/translation/translation';
import { DangerButton } from '../../button/DangerButton';
import { SecondaryButton } from '../../button/SecondaryButton';
import { Modal } from '../../modal/Modal';

type Props = {
  onClose: () => void;
};

export const LogoutModal = ({ onClose }: Props) => {
  const { logoutMutation } = useAuth();

  return (
    <Modal onClose={onClose}>
      <Modal.Header onClose={onClose} />
      <Modal.Body>
        <CircleQuestionRegular width={42} height={42} className="mx-auto mb-4 fill-gray-400  dark:fill-gray-200" />
        <h3 className="text-lg font-normal text-gray-500 dark:text-gray-400 text-center">
          {t('side-bar.logout-confirmation')}
        </h3>
      </Modal.Body>
      <Modal.Footer compressed>
        <DangerButton onClick={() => logoutMutation.mutate()}>{t('logout-modal.yes')}</DangerButton>
        <SecondaryButton onClick={onClose}>{t('logout-modal.no')}</SecondaryButton>
      </Modal.Footer>
    </Modal>
  );
};
